import React, { PropTypes } from 'react'
import classNames from 'classnames'
import StampSwatch from './StampSwatch'

const StampGrid = ({ stamps, selectedStamp, selectedWeight, onSelectStamp, className}) => (
  <div className={classNames(['stamp-grid', className])}>
    <div className="include-paintfill">Includes Paintfill</div>
    {stamps.map(stamp =>
      <StampSwatch key={stamp.id} 
        stamp={stamp} 
        disabled={selectedWeight && stamp.disabledWeightIds.split(',').indexOf(selectedWeight.id.toString()) > -1 }
        selected={stamp.id === (selectedStamp && selectedStamp.id)} 
        onClick={onSelectStamp} />
    )}
  </div>
)

StampGrid.propTypes = {
  className: PropTypes.string,
  stamps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  selectedStamp: PropTypes.shape({
    id: PropTypes.number,
  }),
  onSelectStamp: PropTypes.func.isRequired,
} 

export default StampGrid;